import { gql } from '@apollo/client';
import { DRIVER_TARIFF_FIELDS } from '@/graphql/fragments/driver_tariffs';
import { PRICING_TARIFF_FIELDS } from '@/graphql/fragments/pricing_tariffs';
import { RATE_FIELDS } from '@/graphql/fragments/rates';

export const GET_DRIVER_TARIFF_BY_DRIVER_ID = gql`
    ${DRIVER_TARIFF_FIELDS}
    ${PRICING_TARIFF_FIELDS}
    ${RATE_FIELDS}

    query GetDriverTariffByDriverId($driver_id: uuid!) {
        driver_tariff_mappings(where: { driver_id: { _eq: $driver_id } }, limit: 1) {
            ...DriverTariffFields
            tariff {
                ...PricingTariffFields
                rates {
                    ...RateFields
                }
            }
        }
    }
`;
